const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;
import selfOrClosest from '../../util/self-or-closest'

const MOBILE_NAV_BREAKPOINT = 1080

class Menu {
  constructor(element) {
    this.element = element
    this.headerBanner = this.element.querySelector('.header__banner')
    this.headerMain = this.element.querySelector('.header__main')
    this.navWrapper = this.element.querySelector('.nav-wrapper')
    this.primaryNavItems = [...this.element.querySelectorAll('.nav-primary__item')]
    this.burgerButton = this.element.querySelector('.hamburger')
    this.sentinal = document.querySelector('.header__main-sentinel')

    this.mouseOutTimeout = null
    this.closeTimeout = null

    // this.handleSentinal = this.handleSentinal.bind(this)
    this.handlePrimaryNavMouseOver = this.handlePrimaryNavMouseOver.bind(this)
    // this.handlePrimaryNavMouseOut = this.handlePrimaryNavMouseOut.bind(this)
    this.handlePrimaryNavClick = this.handlePrimaryNavClick.bind(this)
    this.handleBurgerClick = this.handleBurgerClick.bind(this)
    this.resizeHandler = this.resizeHandler.bind(this)
    this.scrollHandler = this.scrollHandler.bind(this)
    this.scrollTick = this.scrollTick.bind(this)
    this.handleBodyClick = this.handleBodyClick.bind(this)

    // Set a conservative header height incase things take a minute to load
    this.headerFullHeight = 150

    // const observer = new IntersectionObserver(this.handleSentinal);
		// observer.observe(this.sentinal);
  }

  // handleSentinal([{ isIntersecting }]) {
  //   // if (window.innerWidth < MOBILE_NAV_BREAKPOINT) {
  //   //   this.element.classList.toggle('nav-locked', !isIntersecting)
  //   // }
  // }

  open(primaryNavItem) {
    clearTimeout(this.mouseOutTimeout)
    clearTimeout(this.closeTimeout)

    if (primaryNavItem === this.primaryNavItem) {
      return;
    }

    this.prevNavItem = this.primaryNavItem
    this.primaryNavItem = primaryNavItem

    this.element.classList.add('nav-ready')
    primaryNavItem.classList.add('ready')

    requestAnimationFrame(() => {
      document.body.classList.add('nav-open')
      this.element.classList.add('nav-active')

      if (this.prevNavItem) {
        const subItem = primaryNavItem.querySelector('.nav-primary__sub')
        if (subItem) {
          subItem.style.transition = 'none';
        }
      }

      primaryNavItem.classList.add('active')

      if (this.prevNavItem) {
        this.prevNavItem.classList.remove('active')
        this.prevNavItem.classList.remove('ready')
      }

      setTimeout(() => {
        document.body.addEventListener('click', this.handleBodyClick)
      })
    })
  }

  close() {
    this.element.classList.remove('nav-active')
    document.body.classList.remove('nav-open')

    // restore sub nav transitions so they can be animated out

    this.element.querySelectorAll('.nav-primary__sub').forEach((sub) => {
      sub.style.transition = ''
    })


    this.element.querySelectorAll('.nav-primary__item.active').forEach((activeItem) => {
      activeItem.classList.remove('active')
    })

    this.closeTimeout = setTimeout(() => {

      this.primaryNavItem = null

      this.element.classList.remove('nav-ready')
      this.element.querySelectorAll('.nav-primary__item.ready').forEach((activeItem) => {
        activeItem.classList.remove('ready')
      })

      enableBodyScroll(this.navWrapper);
    }, 250)
  }

  handleBodyClick(event) {
    if (!selfOrClosest(event.target, '.nav-primary')) {
      this.close()
    }
  }

  handleBurgerClick(event) {
    if (this.element.classList.contains('mobile-nav-open')) {
      this.closeMobileNav()
      return;
    }

    this.openMobileNav()
  }

  handlePrimaryNavMouseOver(event) {
    const primaryNavItem = event.target.closest('.nav-primary__item')
    if (!primaryNavItem.classList.contains('has-sub-items')) {
      this.close()
    }
    // console.log(primaryNavItem)
    // this.open(primaryNavItem)
  }

  handlePrimaryNavMouseOut(event) {
    console.log('mouse out')
    this.mouseOutTimeout = setTimeout(() => {
      this.close()
    }, 500)
  }

  handlePrimaryNavClick(event) {
    // if (window.innerWidth <= MOBILE_NAV_BREAKPOINT) {
      // Treat parent items without children and children as standard links
      if (!event.target.closest('.has-sub-items') || event.target.closest('.nav-primary__sub')) {
        return;
      }

      event.preventDefault()

      if (event.target.closest('.active')) {
        this.close()
        return;
      }

      const primaryNavItem = event.target.closest('.nav-primary__item')
      this.open(primaryNavItem)
    // }
  }

  resizeHandler() {

    if (window.innerWidth >= MOBILE_NAV_BREAKPOINT) {
      this.closeMobileNav()
    }

    this.setupPrimaryNavEventHandlers()

    document.documentElement.style.setProperty('--header-banner-height', `auto`);

    requestAnimationFrame(() => {
      const bannerRect = this.headerBanner.getBoundingClientRect()
      document.documentElement.style.setProperty('--header-banner-height', `${bannerRect.height}px`);

      this.headerFullHeight = this.element.getBoundingClientRect().height
    })

    this.updateSubItemHeight()
  }

  closeMobileNav() {
    document.body.classList.remove('nav-open')
    this.element.classList.remove('mobile-nav-open')
    this.burgerButton.classList.remove('is-active')
    enableBodyScroll(this.navWrapper)
  }

  openMobileNav() {
    document.body.classList.add('nav-open')
    this.element.classList.add('mobile-nav-open')
    this.burgerButton.classList.add('is-active')
    disableBodyScroll(this.navWrapper)
  }

  updateSubItemHeight() {

    let maxHeight = 0;
    this.primaryNavItems.forEach((primaryItem) => {
      const subItem = primaryItem.querySelector('.nav-primary__sub')

      if (!subItem) {
        return;
      }

      const subItemHeight = subItem.getBoundingClientRect().height

      if (subItemHeight > maxHeight) {
        maxHeight = subItemHeight
      }
    })

    document.documentElement.style.setProperty('--primary-nav-sub-item-height', `${maxHeight}px`);
  }

  setupPrimaryNavEventHandlers() {
    this.primaryNavItems.forEach((primaryNavItem) => {

      // if (!primaryNavItem.classList.contains('has-sub-items')) {
      //   return;
      // }

      primaryNavItem.addEventListener('click', this.handlePrimaryNavClick)

      if (window.innerWidth <= MOBILE_NAV_BREAKPOINT) {
        primaryNavItem.removeEventListener('mouseover', this.handlePrimaryNavMouseOver)
      //   primaryNavItem.removeEventListener('mouseout', this.handlePrimaryNavMouseOut)

      //   primaryNavItem.removeEventListener('click', this.handlePrimaryNavClick)
      //   primaryNavItem.addEventListener('click', this.handlePrimaryNavClick)
      } else {

        primaryNavItem.removeEventListener('mouseover', this.handlePrimaryNavMouseOver)
      //   primaryNavItem.removeEventListener('mouseout', this.handlePrimaryNavMouseOut)

        primaryNavItem.addEventListener('mouseover', this.handlePrimaryNavMouseOver)
      //   primaryNavItem.addEventListener('mouseout', this.handlePrimaryNavMouseOut)

      //   primaryNavItem.removeEventListener('click', this.handlePrimaryNavClick)
      }
    })
  }

  scrollTick() {
    if (this.scrolling) {

      if (this.primaryNavItem) {
          this.close();
      }

      if (window.scrollY > this.headerFullHeight) {
        this.element.classList.add('nav-locked')

        setTimeout(() => {
          this.element.classList.add('nav-reveal-ready')
        }, 250)

        if (window.scrollY < (this.lastScrollTop - 100)) {
          if (this.element.classList.contains('nav-reveal-ready')) {
            this.element.classList.add('nav-reveal')
          }
        } else if (window.scrollY > (this.lastScrollTop + 100) || window.scrollY == 0) {
          this.element.classList.remove('nav-reveal')
        }

      } else {
        this.element.classList.remove('nav-locked')
        this.element.classList.remove('nav-reveal-ready')
        this.element.classList.remove('nav-reveal')
      }
    }

    this.lastScrollTop = window.scrollY
    this.scrolling = false
  }

  scrollHandler() {
    this.scrolling = true
  }

  init() {

    this.setupPrimaryNavEventHandlers()

    this.burgerButton.addEventListener('click', this.handleBurgerClick)
    window.addEventListener('resize', this.resizeHandler);
    window.addEventListener('scroll', this.scrollHandler);

    setInterval(this.scrollTick, 250);

    this.lastScrollTop = window.scrollY

    this.updateSubItemHeight()
    this.resizeHandler()
  }
}

export default Menu
